import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { useChangeOfflineInvoiceStatus } from "../../hooks/useCrm";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { DeleteReason } from "../../data/crmGeneralData";
const initvalue = {
  IdOrderOffline: null,
  DescriptionUnsuccessful: "",
};
export const ChangeToUnsuccessfulModal = ({ show, handleClose, factorId }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: changeStatus } = useChangeOfflineInvoiceStatus();
  useEffect(() => {
    setForm({ ...form, IdOrderOffline: factorId });
  }, [factorId]);
  const handleChangeStatus = async (data) => {
    await changeStatus(data).then(() => setForm(initvalue));
  };
  const DeleteReasons = DeleteReason?.map((reason) => {
    return {
      value: reason.value,
      label: reason.label,
    };
  });
  return (
    <BootstrapModal
      modaltitle="تبدیل به ناموفق"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12 mb-2">
          <SimpleSelect1
            label="انتخاب دلیل"
            res={DeleteReasons}
            onChange={(e) =>
              setForm({ ...form, DescriptionUnsuccessful: e.value })
            }
          />
        </div>
        <div className="col-6">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleChangeStatus(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
